import React from 'react';
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import {useDeleteIntegration} from '../../hooks/api/integrations';
import {useNavigate} from 'react-router';
import {
  useIntegrationStaticInfo,
  useIntegrationFromContext,
} from './IntegrationDetailsContext';

export function DeleteIntegrationModal({
  isOpen,
  onClose,
  warningMessage,
}: {
  isOpen: boolean;
  onClose: () => void;
  warningMessage?: string;
}) {
  const integration = useIntegrationFromContext();
  const integrationInfo = useIntegrationStaticInfo();
  const deleteIntegration = useDeleteIntegration();
  const navigate = useNavigate();
  const toast = useToast();

  return (
    <Modal isCentered={true} isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete {integrationInfo.label}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to delete this integration?
          {warningMessage && (
            <Alert status="warning" mt={4} alignItems="start">
              <AlertIcon />
              <AlertDescription>{warningMessage}</AlertDescription>
            </Alert>
          )}
        </ModalBody>
        <ModalFooter gap="4">
          <Button isLoading={deleteIntegration.isPending} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            isLoading={deleteIntegration.isPending}
            onClick={() => {
              deleteIntegration.mutate(integration.type, {
                onSuccess: () => {
                  toast({
                    title: 'The integration has been deleted.',
                    status: 'success',
                    isClosable: true,
                    duration: 2_000,
                  });
                  navigate('/settings/integrations');
                },
              });
            }}
          >
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
